































































































/* eslint-disable no-undef */
import Vue from 'vue'
import FinanceService from '@/services/FinanceService'
import format from 'date-fns/format'
import { UserWithdrawRecord } from '@/types'
import { Paging } from '@/util/paging'

export default Vue.extend({
  components: {},
  data () {
    return {
      userWithdrawRecords: [] as UserWithdrawRecord[],
      userWithdrawRecordsPaging: {} as Paging<UserWithdrawRecord>
    }
  },
  async mounted () {
    console.log('#Page: UserWithdraw')

    // get account role list
    this.userWithdrawRecordsPaging =
      FinanceService.getUserWithdrawRecordsPaging({ detail: true })
    await this.userWithdrawRecordsPaging.getMoreData()
  },
  methods: {
    async approveAndFulfillUserWithdrawRequest (userWithdrawId: number) {
      const res = await FinanceService.approveAndFulfillUserWithdrawRequest(
        userWithdrawId
      )
      console.log(`审核结果: ${res.data.msg}`)
      if (parseInt(res.data.errorCode) === 0) {
        this.$router.go(0)
      }
    },
    dateFormat (timeDate: number | Date, formatString: string) {
      return format(timeDate, formatString)
    },
    async moreRecords () {
      await this.userWithdrawRecordsPaging.getMoreData()
    }
  }
})
